import {UyapRequest} from "./UyapRequest";
import JSZip from "jszip";

export class TakipTalebiIndirTalep {
    download: boolean = true;
    filename: string = "takip_talebi.udf";
}

export interface TakipTalebiIndirCevap {
    file: Blob
}


export default class TakipTalebiIndir extends UyapRequest<TakipTalebiIndirTalep, TakipTalebiIndirCevap> {
    dosyaId: string = "";
    delayTime = 1000;

    constructor(dosyaId: string) {
        super();
        this.dosyaId = dosyaId;
    }

    getMethod(): 'GET' | 'POST' {
        return 'GET';
    }

    getSpinnerMessage(){
        return "Takip talebi indiriliyor...";
    }


    cache() {
        return {
            active: false,
            ttl: (60 * 24), //* 1 gun
            key: "_"
        };
    }

    getMockResponse(): Blob {
        return new Blob(["<takiptalebi>…</takiptalebi>"], {type: 'application/octet-stream'});
    }

    getUrl(): string {
        return this.ImzaClientAddr + "icraTakipTalebiIndir.uyap?dosyaId=" + encodeURIComponent(this.dosyaId);
    }

    async parse(data: any): Promise<TakipTalebiIndirCevap> {
        return new Promise((resolve, reject) => {
            let blobData = data;
            let reader = new FileReader();
            reader.readAsText(data); //udf base64 ceviriliyor..
            reader.onloadend = () => {
                let textContent = reader.result;
                //@ts-ignore
                if (textContent.substr(0, 2) == "PK") {
                    console.log("Takip Talebi Indir parser IF ")
                    return resolve({file: blobData});
                } else {
                    console.log("Takip Talebi Indir parser ELSE ")
                    /**
                     * 08/04/2019
                     * uyap güncellemesi ile
                     * GELEN UDF zip olarak gelmiyor artık gelen xml datası mı diye text e çevirilip kontrol ediliyor.
                     * eğer zip olarak gelirse X tarihte ona göre de kontrol koyuldu.
                     * PK gelen data zip mi değilmi kontrolüdür..
                     * Emre
                     * @return zip blob data;
                     */
                    let zip = new JSZip();
                    zip.file("content.xml", blobData);
                    zip.generateAsync({
                        type: "blob",
                        compression: "DEFLATE",
                        compressionOptions: {
                            level: 6
                        }
                    }).then((content) => {
                        let blob = new Blob([content], {type: "application/octet-stream"});//udf type ına çeviriliyor.
                        console.log("UDF CONVERTING BLOB", blob);
                        return resolve({file: blob});
                    }).catch(function (err) {
                        return reject(err);
                    });
                }
            }
        })
    }
}
